<template>
  <div class="container-fluid">
    <div
      class="page-content__header-description"
      style="display: flex; justify-content: space-between; margin-top:40px"
    >
      <h2 style="margin:0">
        Customer Onboarding Stats
      </h2>
      <DateRangePicker
        v-model="dateRange"
        @input="handleDateRangeChange"
      />
    </div>
    <OnboardingMetrics :dateRange="dateRange" />
    <ListOnboardingTracker :dateRange="dateRange" />
  </div>
</template>

<script>
import ListOnboardingTracker from "./ListOnboardingTracker.vue";
import OnboardingMetrics from "./OnboardingMetrics.vue";
import DateRangePicker from "@/components/pages/kitchen/date-range-picker";
// import DateRangePicker from "../../kitchen/DateRangePicker";

export default {
  name: "OnboardingTracker",
  components: {
    ListOnboardingTracker,
    OnboardingMetrics,
    DateRangePicker
  },
  data() {
    return {
      usertype: localStorage.roleType,
      dateRange: {
        start: new Date(2024, 7, 31),
        end: new Date()
      }
    };
  },
  computed: {},
  methods: {
    handleDateRangeChange(newDateRange) {
      console.log("Date range changed:", newDateRange);
      this.dateRange = newDateRange;
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/onboardingTracker/OnboardingTracker.vue